<app-cms-dom id="cms-dom" [page_id]="page_id" [title]="title"></app-cms-dom>
